import axios from 'axios'

const API_URL = process.env.VUE_APP_URL_API + '/vendors'

class VendorService {
  getVendors () {
    return axios
      .get(API_URL)
      .then(response => {
        return response.data
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }

  addAccount ({credential, vendorId}) {
    return axios.post(API_URL, {
        credential: credential,
        vendorId: vendorId,
    })
    .then(response => {
        return response.data
    })
    .catch(err => {
        return Promise.reject(err)
    })
  }

  deleteAccount (user) {
    return axios.post(API_URL, {
      username: user.username,
      email: user.email,
      password: user.password,
    })
  }
}

export default new VendorService()
